import { WallConfig, WallPropConfig } from "@/state/RoomConfig/WallConfig";
import React, { useMemo } from "react";
import { useFurnitureWithModel, useResourcesState } from "@/state/resourcesState";
import { createModelInstance } from "@/3d/modelInstance/ModelInstance";
import { FurnitureInstanceRenderer } from "../FurnitureInstanceRenderer";
import { FurnitureInstance } from "@/state/Furniture";
import { getBoundingRectFromMinAndSize } from "@/3d/BoundingRect";
import { useWallPropData } from "./useWallPropData";

type DoorPropViewProps = {
    prop: WallPropConfig;
    wall: WallConfig;
};

// todo: a lot of hardcode - need to fix
export const DoorPropView: React.FC<DoorPropViewProps> = ({ prop, wall }) => {
    const { position, floorOffset, isSelected } = useWallPropData(prop);

    const door = useFurnitureWithModel({ name: "Дверь" });
    const materials = useResourcesState((state) => state.materials);
    const isLoaded = useResourcesState((state) => state.isLoaded);

    const instance = useMemo<FurnitureInstance | undefined>(() => {
        if (!door) {
            return undefined;
        }

        const instance = createModelInstance(
            door.model.raw,
            door.model.config,
            door.model.raw.meshStats,
            materials,
            getBoundingRectFromMinAndSize(
                { x: 0, y: 0, z: 0 },
                {
                    x: door.model.raw.boundingRect.sizeX,
                    y: prop.height,
                    z: prop.width,
                }
            )
        );

        // todo: add ability to define material slot colors to editor
        const wallColorSlot = Object.values(instance.config.materialSlots).find(
            (slot) => slot.name === "WallColor"
        );

        if (wallColorSlot) {
            instance.materialSlotMapping[wallColorSlot.id].color = wall.color;
            instance.materialSlotMapping[wallColorSlot.id].ignoreTextureColor = true;
        }

        return { id: prop.key, instance, furnitureId: door.id, type: "wallProp" };
    }, [door, materials, isLoaded, prop, wall]);

    if (!instance || !isLoaded) {
        return (
            <mesh
                position={[position, floorOffset + prop.height / 2, 0]}
                scale={[prop.width, prop.height, 1]}
            >
                <boxGeometry />
                <meshBasicMaterial color="yellow" />
            </mesh>
        );
    }

    return (
        <group
            position={[
                position - instance.instance.box.sizeZ / 2,
                floorOffset,
                0.0913 /* todo: set origin via config editor */,
            ]}
            rotation={[0, Math.PI / 2, 0]}
        >
            <FurnitureInstanceRenderer furniture={instance} isSelected={isSelected} />
        </group>
    );
};
